import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ThirdPartyLicenseOffering} from './third-party-license-offering.service';
import {Observable} from 'rxjs';
import {Page} from '@uofu-uss/angular-util';

@Injectable({
  providedIn: 'root'
})
export class ThirdPartyLicenseOfferingDataService {

  public static readonly baseUrl = '/api/third-party-license-offering';

  private readonly http = inject(HttpClient);

  search(thirdPartyLicenseId: number | undefined, unid: string): Observable<Page<ThirdPartyLicenseOffering>> {
    let params = new HttpParams()
      .set('thirdPartyLicenseId', thirdPartyLicenseId)
      .set('unid', unid);

    return this.http.get<Page<ThirdPartyLicenseOffering>>(`${ThirdPartyLicenseOfferingDataService.baseUrl}`, {params});
  }
}
